import { render } from "./modal_ingredients.vue?vue&type=template&id=666ab47c&scoped=true"
import script from "./modal_ingredients.vue?vue&type=script&lang=js"
export * from "./modal_ingredients.vue?vue&type=script&lang=js"

import "./modal_ingredients.vue?vue&type=style&index=0&id=666ab47c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666ab47c"]])

export default __exports__